document.addEventListener("DOMContentLoaded", () => {
  const productGrid = document.querySelector("body.page-collections #product-grid")
  const container = document.querySelector("body.page-collections #ProductGridContainer")
  if (!productGrid || !container) return

  let currentPage = 1
  const maxPages = parseInt(container.dataset.maxPages, 10)
  let loading = false

  function loadNextPage() {
    if (loading || currentPage >= maxPages) return

    loading = true
    const nextPage = currentPage + 1
    const url = new URL(window.location.href)
    url.searchParams.set("page", nextPage)

    fetch(url)
      .then(res => res.text())
      .then(html => {
        const tempDiv = document.createElement("div")
        tempDiv.innerHTML = html
        const newProducts = tempDiv.querySelectorAll(
          ".page-collections .product-grid-container #product-grid > li.grid__item"
        )

        if (newProducts.length) {
          newProducts.forEach(p => {
            p.classList.add("product-fade-in")
          })
          const fragment = document.createDocumentFragment()
          newProducts.forEach(p => fragment.appendChild(p))
          productGrid.appendChild(fragment)

          // Optionally remove the class after the animation
          setTimeout(() => {
            newProducts.forEach(p => p.classList.remove("product-fade-in"))
          }, 700)
        }

        currentPage++
      })

      .catch(err => console.error("Error loading next page:", err))
      .finally(() => {
        loading = false
      })
  }

  window.addEventListener("scroll", () => {
    const scrollPos = window.scrollY + window.innerHeight
    const threshold = productGrid.offsetTop + productGrid.offsetHeight - 300
    if (scrollPos >= threshold) {
      loadNextPage()
    }
  })
})
